import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from 'react-bootstrap/lib/Button';
import ChevronLeftIcon from 'components/icons/ChevronLeftIcon.com.svg';
import cns from 'classnames';
import { LINK_FORCE_REFRESH } from 'config';
import * as actions from './actions';
import cn from './styles.local.less';

class BackLink extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    forceRefresh: PropTypes.bool,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    forceRefresh: LINK_FORCE_REFRESH,
  };

  handleClick = () => {
    const { onClick, forceRefresh } = this.props;

    onClick(forceRefresh);
  };

  render() {
    const { children, className } = this.props;

    return (
      <Button
        data-qa-selector="backBtn"
        className={cns(cn.root, className)}
        onClick={this.handleClick}
        bsStyle="link"
      >
        <ChevronLeftIcon className={cn.iconLeftChevron} />
        {children}
      </Button>
    );
  }
}

export default connect(null, actions)(BackLink);
